import { Plus, Variable } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface VariableGroupsEmptyStateProps {
  canManage: boolean
  onCreate: () => void
}

export function VariableGroupsEmptyState({ canManage, onCreate }: VariableGroupsEmptyStateProps) {
  return (
    <div data-testid="variable-groups-empty-state" className="flex flex-col items-center justify-center rounded-lg border border-dashed py-16">
      <Variable className="h-12 w-12 text-muted-foreground" />
      <h3 className="mt-4 text-lg font-semibold">No environment variable groups yet</h3>
      <p className="mt-1 text-sm text-muted-foreground">
        Group the variables your workflow runs need, such as test user credentials or environment URLs.
      </p>
      {canManage && (
        <Button className="mt-4" onClick={onCreate}>
          <Plus className="mr-2 h-4 w-4" />
          New Environment Variable Group
        </Button>
      )}
    </div>
  )
}
